import { createFormatForDescription as cffd } from '../createFormatForDescription'
import { Explanation, explain } from '../explain/Explanation'
import EscrowCancelInstructions from '../types/instructions/EscrowCancelInstructions'
import TransactionType from '../types/TransactionType'

/**
 * An annotation for EscrowCancel transactions.
 *
 * @property type - The type of the transaction.
 * @property offerSequence - An explanation of the offerSequence.
 * @property owner - An explanation of the owner.
 */
export interface EscrowCancelAnnotation {
  readonly type: TransactionType.EscrowCancel
  readonly offerSequence: Explanation<number>
  readonly owner: Explanation<string>
}

/**
 * Takes a transaction object and returns an annotated transaction object.
 * The returned object contains explanations about the various transaction features.
 *
 * @param transactionInstructions - The input transaction.
 * @returns An annotated transaction object detailing the various transaction features.
 */
export function annotate(
  transactionInstructions: EscrowCancelInstructions,
): EscrowCancelAnnotation {
  const offerSequence = explain(
    transactionInstructions.OfferSequence,
    `Cancel the escrow transaction with transaction sequence ${cffd(
      transactionInstructions.OfferSequence.toString(),
      'offerSequence',
    )}`,
  )

  const owner = explain(
    transactionInstructions.Owner,
    `The original address that funded the escrow transaction as ${cffd(
      transactionInstructions.Owner,
      'owner',
    )}`,
  )

  return {
    offerSequence,
    owner,

    type: TransactionType.EscrowCancel,
  }
}
